import React, { useState } from "react";
import { db } from "../firebaseConfig";
import {
  collection,
  addDoc,
  getDocs,
  //where,
  //query,
} from "firebase/firestore";
import {
  Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, Typography, Checkbox,
  TextField, Paper, Grid, Button
} from '@mui/material';
import jsPDF from "jspdf";

const inspectionItems = [
  "Revisión de daños eléctricos",
  "Revisión de daños interiores",
  "Revisión de indicadores",
  "Revisión de ventanas",
];

const lucesInspectionItems = [
  "Revisión de luces zepelines, reversos, direccional, laterales",
  "Revisión de cuartos y luces de freno",
  "Revisión de luces delanteras",
  "Revisión de luces de marcador",
  "Revisión de angueras de servicio y chirrión de luces",
  "Revisión de luz de placa"
];

const ejeDelanteroyDireccionItems = [
  "Revision de pernos de dirección",
  "Revision de baleros",
  "Revision de brazo viajero",
  "Revision de barra de dirección y terminales",
  "Revisión de abrazaderas de muelles",
];

const frenosItems = [
  "Revisión de frenos discos /tambores",
  "Ajuste de frenos",
  "Revision de Rotachamber",
  "Bolsas de aire",
  "Revision de amortiguadores",
  "Barra Cardan y Yugo",
  "Revision porta gavilanes",
  "Revision de juego de 5ta rueda",
  "Revision de mangueras de aire"
];

const FluidosItems = [
  "Aceite de motor",
  "Nivel de refrigerante",
  "Aceite de las masas",
  "Aceite de dirección hidraulica",
  "Transmision y diferenciales",
];

const fugasItems = [
  "Anticongelante",
  "Aceite de motor",
  "Aceite de dirección",
  "Aceite de transmisión",
  "Aceite de diferencial delantero",
  "Aceite de diferencial trasero",
  "Aceite de las masas de cada rueda",
  "Fugas de aire",
];

const miscelaneosItems = [
  "Revision de baterias y mancuernas",
  "Revision de bandas y poleas",
];

const equipoSeguridadItems = [
  "Triangulos de Advertencia",
  "Extintor",
  "Manibela extra",
  "Cadenas de nieve 3 bolsas (solo b1)",
];

const sistemaDef = [
  "Revisión de fugas de bomba DEF",
  "Revision % de saturación Filtros DEF",
  "Revisión de auto regeneración encendida",
];

const TruckInspectionForm = () => {
  const [folio, setFolio] = useState("");
  const [loading, setLoading] = useState(false);

  const [formStateGeneral, setFormStateGeneral] = useState(
    inspectionItems.map(() => ({ ok: false, ajuste: false, adicional: false, comentario: '' }))
  );
  const [formStateLuces, setFormStateLuces] = useState(
    lucesInspectionItems.map(() => ({ ok: false, ajuste: false, adicional: false, comentario: '' }))
  );
  const [formStateEjeDelantero, setFormStateEjeDelantero] = useState(
    ejeDelanteroyDireccionItems.map(() => ({ ok: false, ajuste: false, adicional: false, comentario: '' }))
  );
  const [formStateFrenos, setFormStateFrenos] = useState(
    frenosItems.map(() => ({ ok: false, ajuste: false, adicional: false, comentario: '' }))
  );
  const [formStateFluidos, setFormStateFluidos] = useState(
    FluidosItems.map(() => ({ ok: false, ajuste: false, adicional: false, comentario: '' }))
  );
  const [formStateFugas, setFormStateFugas] = useState(
    fugasItems.map(() => ({ ok: false, ajuste: false, adicional: false, comentario: '' }))
  );
  const [formStateMiscelaneos, setFormStateMiscelaneos] = useState(
    miscelaneosItems.map(() => ({ ok: false, ajuste: false, adicional: false, comentario: '' }))
  );
  const [formStateSeguridad, setFormStateSeguridad] = useState(
    equipoSeguridadItems.map(() => ({ ok: false, ajuste: false, adicional: false, comentario: '' }))
  );
  const [formStateSistemaDef, setFormStateSistemaDef] = useState(
    sistemaDef.map(() => ({ ok: false, ajuste: false, adicional: false, comentario: '' }))
  );


  const getNextFolio = async () => {
    const snapshot = await getDocs(collection(db, "inspecciones"));
    const folios = snapshot.docs
      .map(doc => doc.data().folio)
      .filter(folio => folio?.startsWith("ITS"))
      .map(folio => parseInt(folio.replace("ITS", "")))
      .filter(num => !isNaN(num));

    const maxFolio = folios.length > 0 ? Math.max(...folios) : 0;
    return `ITS${String(maxFolio + 1).padStart(4, '0')}`; // ejemplo: ITS0001
  };


  const generateFolio = async () => {
    const snapshot = await getDocs(collection(db, "inspecciones"));
    const count = snapshot.size + 1;
    return `ITS-${count.toString().padStart(6, "0")}`;
  };
  
  const generarPDF = (folio, data) => {
    const doc = new jsPDF();
    doc.setFontSize(16);
    doc.text(`Folio: ${folio}`, 10, 10);
    doc.text(`Fecha: ${new Date().toLocaleString()}`, 10, 20);

    const agregarSeccion = (titulo, items, estado, yStart) => {
      doc.setFontSize(12);
      doc.text(titulo, 10, yStart);
      let y = yStart + 5;
      items.forEach((item, i) => {
        const val = estado[i];
        const detalles = `OK: ${val.ok ? "✓" : "X"}, Ajuste: ${val.ajuste ? "✓" : "X"}, Adicional: ${val.adicional ? "✓" : "X"}`;
        const comentario = val.comentario ? ` Comentario: ${val.comentario}` : "";
        doc.text(`- ${item}: ${detalles}${comentario}`, 10, y);
        y += 6;
        if (y > 280) {
          doc.addPage();
          y = 10;
        }
      });
      return y;
    };

    let y = 30;
    y = agregarSeccion("Inspección General", inspectionItems, data.general, y);
    y = agregarSeccion("Luces", lucesInspectionItems, data.luces, y);
    y = agregarSeccion("Eje Delantero", ejeDelanteroyDireccionItems, data.ejeDelantero, y);
    y = agregarSeccion("Frenos", frenosItems, data.frenos, y);
    y = agregarSeccion("Fluidos", FluidosItems, data.fluidos, y);
    y = agregarSeccion("Fugas", fugasItems, data.fugas, y);
    y = agregarSeccion("Misceláneos", miscelaneosItems, data.miscelaneos, y);
    y = agregarSeccion("Equipo de Seguridad", equipoSeguridadItems, data.seguridad, y);
    y = agregarSeccion("Sistema DEF", sistemaDef, data.sistemaDef, y);

    doc.save(`${folio}.pdf`);
  };


  const handleCheckboxChange = (index, field, section) => {
    const states = {
      general: [formStateGeneral, setFormStateGeneral],
      luces: [formStateLuces, setFormStateLuces],
      ejeDelantero: [formStateEjeDelantero, setFormStateEjeDelantero],
      frenos: [formStateFrenos, setFormStateFrenos],
      fluidos: [formStateFluidos, setFormStateFluidos],
      fugas: [formStateFugas, setFormStateFugas],
      miscelaneos: [formStateMiscelaneos, setFormStateMiscelaneos],
      seguridad: [formStateSeguridad, setFormStateSeguridad],
      sistemaDef: [formStateSistemaDef, setFormStateSistemaDef],
    };

    const [state, updater] = states[section];
    const newState = [...state];
    newState[index][field] = !newState[index][field];
    updater(newState);
  };

  const handleCommentChange = (index, value, section) => {
    const states = {
      general: [formStateGeneral, setFormStateGeneral],
      luces: [formStateLuces, setFormStateLuces],
      ejeDelantero: [formStateEjeDelantero, setFormStateEjeDelantero]
    };

    const [state, updater] = states[section];
    const newState = [...state];
    newState[index].comentario = value;
    updater(newState);
  };
  const handleGuardar = async () => {
    const folioGenerado = await generateFolio();

    const data = {
      folio: folioGenerado,
      fecha: new Date().toISOString(),
      general: formStateGeneral,
      luces: formStateLuces,
      ejeDelantero: formStateEjeDelantero,
      frenos: formStateFrenos,
      fluidos: formStateFluidos,
      fugas: formStateFugas,
      miscelaneos: formStateMiscelaneos,
      seguridad: formStateSeguridad,
      sistemaDef: formStateSistemaDef,
    };

    try {
      const docRef = await addDoc(collection(db, "inspecciones"), data);
      const idDocumento = docRef.id;
      setFolio(folioGenerado);
     // generarPDF(folioGenerado, data);
      alert("Inspección guardada correctamente.");
    } catch (error) {
      console.error("Error al guardar la inspección:", error);
      alert("Ocurrió un error al guardar la inspección.");
    }
  };

  const renderSection = (title, items, state, sectionKey) => (
    <div>
      <Typography variant="h6" sx={{ mt: 4, mb: 2 }}>
        {title}
      </Typography>
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell></TableCell>
              <TableCell align="center">OK</TableCell>
              <TableCell align="center">Requiere Ajuste</TableCell>
              <TableCell align="center">Requiere Trabajo Adicional</TableCell>
              <TableCell>Comentario</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {items.map((item, index) => (
              <TableRow key={index}>
                <TableCell>{item}</TableCell>
                <TableCell align="center">
                  <Checkbox
                    checked={state[index].ok}
                    onChange={() => handleCheckboxChange(index, 'ok', sectionKey)}
                  />
                </TableCell>
                <TableCell align="center">
                  <Checkbox
                    checked={state[index].ajuste}
                    onChange={() => handleCheckboxChange(index, 'ajuste', sectionKey)}
                  />
                </TableCell>
                <TableCell align="center">
                  <Checkbox
                    checked={state[index].adicional}
                    onChange={() => handleCheckboxChange(index, 'adicional', sectionKey)}
                  />
                </TableCell>
                <TableCell>
                  {state[index].adicional && (
                    <TextField
                      fullWidth
                      size="large"
                      placeholder="Describa el trabajo adicional"
                      value={state[index].comentario}
                      onChange={(e) => handleCommentChange(index, e.target.value, sectionKey)}
                    />
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );

  return (
    <Paper sx={{ p: 4, maxWidth: '100%', mx: 'auto' }}>
      <Typography variant="h5" gutterBottom>
        Inspección del Tractocamión
      </Typography>

      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          {renderSection("Inspección General", inspectionItems, formStateGeneral, 'general')}
        </Grid>
        <Grid item xs={12} md={6}>
          {renderSection("Luces", lucesInspectionItems, formStateLuces, 'luces')}
        </Grid>
        <Grid item xs={12} md={6}>
          {renderSection("Eje Delantero y Dirección", ejeDelanteroyDireccionItems, formStateEjeDelantero, 'ejeDelantero')}
        </Grid>
        <Grid item xs={12} md={6}>
          {renderSection("Frenos y Suspensión", frenosItems, formStateFrenos, 'frenos')}
        </Grid>
        <Grid item xs={12} md={6}>
          {renderSection("Fluidos", FluidosItems, formStateFluidos, 'fluidos')}
        </Grid>
        <Grid item xs={12} md={6}>
          {renderSection("Fugas", fugasItems, formStateFugas, 'fugas')}
        </Grid>
        <Grid item xs={12} md={6}>
          {renderSection("Misceláneos", miscelaneosItems, formStateMiscelaneos, 'miscelaneos')}
        </Grid>
        <Grid item xs={12} md={6}>
          {renderSection("Equipo de Seguridad", equipoSeguridadItems, formStateSeguridad, 'seguridad')}
        </Grid>
        <Grid item xs={12} md={6}>
          {renderSection("Sistema DEF", sistemaDef, formStateSistemaDef, 'sistemaDef')}
        </Grid>
      </Grid>

      <Grid item xs={12}>
        {folio && (
          <Typography variant="h6" sx={{ mt: 4 }}>
            Folio generado: <strong>{folio}</strong>
          </Typography>
        )}

        <Button
          variant="contained"
          color="primary"
          sx={{ mt: 4 }}
          onClick={handleGuardar}
        >
          Guardar inspección
        </Button>
      </Grid>

    </Paper>
  );
}

export default TruckInspectionForm;